module.exports = __webpack_public_path__ + "media/images/brand-assets/print-4cd0f04a178ae3f46f6b825d26bb0a9e.png";